import { Box } from "@mui/material";
import { ReactComponent as IconLoading } from "assets/svg/loading-icon.svg";

interface Props {
  size?: string;
}

const LoadingIcon = ({ size = "40px" }: Props) => {
  return (
    <Box
      height={"100%"}
      width={"100%"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <IconLoading width={size} height={size} />
    </Box>
  );
};

export default LoadingIcon;
